export const DASHBOARD_INITIALIZE = 'DASHBOARD_INITIALIZE';
export const DASHBOARD_INITIALIZE_SUCCESS = 'DASHBOARD_INITIALIZE_SUCCESS';
export const DASHBOARD_INITIALIZED = 'DASHBOARD_INITIALIZED';
export const DASHBOARD_CLOSE_ONBOARDING_DIALOG = 'DASHBOARD_CLOSE_ONBOARDING_DIALOG';
export const DASHBOARD_SHOW_ONBOARDING_DIALOG = 'DASHBOARD_INITIALIZED';



// WEBPACK FOOTER //
// ./src/app/stores/dashboard/constants.js